var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',_vm._g(_vm._b({style:({ width: _vm.width }),attrs:{"value":_vm.value},on:{"change":e => _vm.$emit('input', e)}},'a-select',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.options),function(item){return _c('a-select-option',{key:item.value},[_vm._v(" "+_vm._s(item.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }